import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';
import { IPSService } from '@/services/ipsServices';

@Component({
  components: { Upload },
  mixins: [style],
})
export default class Member extends Vue {
  @Prop({ default: () => {} })
    value: DisplayMemberData;

  @Prop()
    disabled: boolean;

  data: DisplayMemberData = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  brandList = [];
  brandNum = Array.from({ length: 10 }, (_, index) => index + 1);

  mounted() {
    this.brandList = this.$store.state.brandList.brandList;
    console.log(this.brandList);
  }

  get brandConfig() {
    return this?.value?.desc?.brandGroupConfig;
  }

  get isShowBrandMore() {
    return this.brandListCheckList.length > this.brandConfig.defalutShowNumber;
  }

  get brandListCheckList() {
    return this.brandList.filter(i => i.check);
  }

  onCheckBoxChange() {
    this.$store.commit('updateBrandList', this.brandList);
  }

  /**
   * 上传图片成功回调
   * @param {val}
   */
  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.data.desc.enterPic = res.content;
  }

  render(h) {
    return (
      <div class="member" key={this.data.sort}>
        <p class="title">入会引导图(未注册/登录时显示)</p>
        <div class="relative-position">
          <Upload noDelete={false} onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.data.desc.enterPic} maxSize={300} disabled={this.disabled} />
          <el-checkbox class="is-pre" v-model={this.data.desc.isPre}>
            预览
          </el-checkbox>
          <p class="tip enter-tip">
            <span class="redText">*&nbsp;</span>点击图片后引导至入会流程
          </p>
          <p class="tip blockTip">注1：&nbsp;建议图片分辨率为750px*300px,不超过300K;</p>
          <p class="tip blockTip">注2：&nbsp;支持jpg、png、gif格式图片;</p>
        </div>
        {/* <p class="blockTitle config-title" style="padding-top: 8px">
          等级有效期
        </p>
        <el-radio-group v-model={value.desc.isShowLevelMax}>
          <el-radio label={1}>显示</el-radio>
          <el-radio label={0}>不显示</el-radio>
        </el-radio-group>
        <p class="blockTitle config-title" style="padding-top: 8px">
          升降级提示
        </p>
        <el-radio-group v-model={value.desc.isShowLevelChange}>
          <el-radio label={1}>显示</el-radio>
          <el-radio label={0}>不显示</el-radio>
        </el-radio-group> */}

        {this.brandList && this.brandList.length ? (
          <div class="ext-caption ">
            <div class="split-line"></div>
            <p class="title">各品牌累计消费金额</p>
            <div class=" q-mb-sm q-mt-sm text-grey-8">
              <el-radio dense v-model={this.brandConfig.isOpen} label={1}>
                显示
              </el-radio>
              <el-radio dense v-model={this.brandConfig.isOpen} label={0}>
                不显示
              </el-radio>
            </div>
            <div class="flex no-wrap q-mb-sm text-grey-8">
              <el-radio dense v-model={this.brandConfig.showType} label={1}>
                显示历史累计消费金额
              </el-radio>
              <el-radio dense v-model={this.brandConfig.showType} label={2}>
                显示近一年累计消费金额
              </el-radio>
            </div>
            <p class="q-mb-sm q-mt-md title text-grey-8">请设置要显示的品牌组，拖动可调整展示顺序</p>
            <draggable scroll={true} scroll-sensitivity={150} force-fallback={true} element="p" class=" no-margin no-padding q-gutter-y-sm" list={this.brandList}>
              {this.brandList.map((i) => {
                const disable = i.check ? false : this.brandList.filter(i => i.check).length >= 10;
                return (
                  <p class="item">
                    <el-checkbox dense class="brandList-draggable" on-change={this.onCheckBoxChange.bind(this)} v-model={i.check} label={i.name} disable={disable} />
                  </p>
                );
              })}
            </draggable>
            <p class="q-pb-md title q-mt-sm text-grey-8 flex items-center">
              收起状态时显示前
              <el-select v-model={this.brandConfig.defalutShowNumber} class="rs-size-sm col bg-white q-mr-sm q-ml-sm" style="max-width:60px;">
                {this.brandNum.map((i) => {
                  return (
                    <el-option label={i} value={i}>
                      {i}
                    </el-option>
                  );
                })}
              </el-select>
              个品牌组
            </p>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}
